import { render, staticRenderFns } from "./refonte-de-site-web-comment-eviter-une-perte-de-trafic-seo.vue?vue&type=template&id=3ae7c2a5&"
import script from "./refonte-de-site-web-comment-eviter-une-perte-de-trafic-seo.vue?vue&type=script&lang=js&"
export * from "./refonte-de-site-web-comment-eviter-une-perte-de-trafic-seo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports